import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import Articles from './articles';

function ArticlesIndex({ match }: InferProps<typeof ArticlesIndex.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={Articles} />
    </Switch>
  );
}

ArticlesIndex.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default ArticlesIndex;
